export const enum LoginStatus {
  // 登录态未知，一般是初始化还没拿到登录态的时候会有
  UNKNOWN = 0,
  // 已登录
  LOGIN = 1,
  // 未登录
  NOT_LOGIN = -1,
}

export const cardStyleMap = {
  noVip: {
    triangleColor: '#111111',
    cardBgColor: '#111111',
    nickColor: '#ffffff',
    fontColor: '#FFE6A5',
    btnColor: '#FFE6A5',
    btnFontColor: '#3D280B',
  },
  vipAndSportAndFamily: {
    triangleColor: '#111111',
    cardBgColor: '#111111',
    nickColor: '#FFE6A5',
    fontColor: '#FFE6A5',
    btnColor: '#FFE6A5',
    btnFontColor: '#3D280B',
  },
  svipAndShortAndFamily: {
    triangleColor: '#32230F',
    cardBgColor: 'linear-gradient(180deg, #35220B 0%, rgba(53, 34, 11, 0) 100%)',
    nickColor: '#FFD9A7',
    fontColor: '#FFD9A7',
    btnColor: '#FFD9A7',
    btnFontColor: '#3D280B',
  },
  sportAndFamily: {
    triangleColor: '#131C35',
    cardBgColor: 'linear-gradient(180deg, rgba(0, 76, 205, 0.2) 0%, #111111 100%)',
    nickColor: '#D5E0FF',
    fontColor: '#D5E0FF',
    btnColor: '#FFD9A7',
    btnFontColor: '#141E38',
  },
  svipExpired: {
    triangleColor: '#111111',
    cardBgColor: '#111111',
    nickColor: '#ffffff',
    fontColor: '#FFD9A7',
    btnColor: '#FFD9A7',
    btnFontColor: '#3D280B',
  },
  vipExpired: {
    triangleColor: '#111111',
    cardBgColor: '#111111',
    nickColor: '#ffffff',
    fontColor: '#FFE6A5',
    btnColor: '#FFE6A5',
    btnFontColor: '#3D280B',
  },
  family: {
    triangleColor: '#32283D',
    cardBgColor: 'linear-gradient(180deg, rgba(194, 131, 245, 0.2) 0%, rgba(194, 131, 245, 0) 100%)',
    nickColor: '#CEADF1',
    fontColor: '#CEADF1',
    btnColor: '#CEADF1',
    btnFontColor: '#32283C',
  },
  jump: {
    triangleColor: '#3F3E27',
    cardBgColor: 'linear-gradient(180deg, rgba(251, 245, 108, 0.2) 0%, rgba(251, 245, 108, 0) 100%)',
    nickColor: '#FAF581',
    fontColor: '#FAF581',
    btnColor: '#FAF581',
    btnFontColor: '#000000',
  },
};